var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "14px",
    viewBox: "0 0 22 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AD721244-71AF-4632-9A5D-CAAA0AE6A96D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272158",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#164194",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Seamless-Checkout",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.00-Seleccionar-metodo",
    transform: "translate(-245.000000, -352.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(18.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(22.000000, 298.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn_visa",
    transform: "translate(205.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    x: 0,
    y: 0,
    width: 22,
    height: 14,
    rx: 1.0575
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31498641,5.07164326 L7.48219884,8.94124267 L6.28635129,8.94124267 L5.38507629,5.85281379 C5.33045356,5.66291598 5.28753571,5.59386223 5.11586428,5.51358725 C4.76093146,5.36306324 4.38604407,5.2525761 4,5.18471878 L4.02633596,5.07250644 L5.95178708,5.07250644 C6.21179942,5.07226784 6.43325772,5.23967202 6.47362921,5.46697597 L6.94962726,7.70604375 L8.1269421,5.07164326 L9.31498641,5.07164326 Z M13.9969344,7.67755908 C14.0018115,6.65642678 12.4011705,6.60032061 12.4119,6.1437027 C12.4119,6.00559521 12.5650387,5.85799282 12.8917996,5.82001326 C13.2742269,5.7874127 13.6594926,5.84706897 14.0066885,5.99264763 L14.2017697,5.17263437 C13.8633762,5.05994797 13.5050098,5.00149058 13.1434543,5 C12.0256392,5 11.2384867,5.52653483 11.2316589,6.27922068 C11.224831,6.8368297 11.7934926,7.14670839 12.2226712,7.33229034 C12.6518498,7.51787229 12.8079147,7.64389538 12.8079147,7.81307706 C12.8079147,8.07202862 12.4567686,8.18769364 12.1309831,8.1920095 C11.7294338,8.19786784 11.3327626,8.11352594 10.9780534,7.9468687 L10.7732181,8.79450345 C11.1742249,8.93266651 11.6011724,9.00237307 12.0314917,8.99993836 C13.219536,8.99993836 13.9969344,8.48203524 14.0008361,7.67583274 M16.9533895,8.93951633 L18,8.93951633 L17.0860447,5.06991692 L16.12527,5.06991692 C15.9109486,5.0665774 15.7166989,5.18106187 15.6375671,5.35735315 L13.9403609,8.94296901 L15.1274298,8.94296901 L15.363478,8.36464387 L16.8148819,8.36464387 L16.9533895,8.93951633 Z M15.6912144,7.56879943 L16.2862119,6.11521803 L16.6295548,7.56879943 L15.6912144,7.56879943 Z M10.9322093,5.06991692 L9.9967951,8.93951633 L8.86532432,8.93951633 L9.80073852,5.06991692 L10.9322093,5.06991692 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnVisa);
export default __webpack_public_path__ + "static/media/icn_visa.dd2d8a7687308a9939944df521991f97.svg";
export { ForwardRef as ReactComponent };